import React, { useState } from "react";
import { toast } from "sonner";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Coins, ArrowUpRight, ArrowDownLeft, Gift, Users, X } from "lucide-react";
import { EARNINGS_TRANSACTIONS } from "../../data/mockData";

const DATA = [
  { name: "Pending", value: 300, color: "#F59E0B" },
  { name: "Clearing", value: 50, color: "#3B82F6" },
  { name: "Available", value: 325, color: "#FFC107" },
  { name: "Paid", value: 375, color: "#22C55E" },
];

const ICONS = { sale: Coins, referral: Users, creator: Gift, payout: ArrowUpRight };

export default function Earnings() {
  const [modal, setModal] = useState(false);
  return (
    <div className="p-4 pb-6">
      <h1 className="text-[24px] font-black">Earnings</h1>

      <div className="mt-5 sb-card p-5">
        <div className="flex items-center gap-4">
          <div className="w-28 h-28 relative shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={DATA} innerRadius={36} outerRadius={54} paddingAngle={2} dataKey="value" stroke="none">
                  {DATA.map((d, i) => <Cell key={i} fill={d.color} />)}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="text-[10px] text-[#A1A1AA]">Total</div>
              <div className="text-[18px] font-black">$675</div>
            </div>
          </div>
          <div className="flex-1 space-y-2">
            {DATA.map((d) => (
              <div key={d.name} className="flex items-center gap-2 text-[12px]">
                <span className="w-2 h-2 rounded-full" style={{ background: d.color }} />
                <span className="text-[#A1A1AA] flex-1">{d.name}</span>
                <span className="font-bold">${d.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3">
        {DATA.map((d) => (
          <div key={d.name} className="sb-card p-4">
            <div className="sb-eyebrow" style={{ fontSize: 10 }}>{d.name}</div>
            <div className="mt-2 text-[20px] font-black" style={{ color: d.color }}>${d.value}</div>
          </div>
        ))}
      </div>

      <button
        onClick={() => setModal(true)}
        data-testid="setup-payouts"
        className="mt-5 sb-btn-primary w-full text-[12px]"
      >
        Set Up Payouts
      </button>

      <div className="mt-6">
        <div className="sb-eyebrow">Transactions</div>
        <div className="mt-3 sb-card divide-y divide-[#2A2F34]">
          {EARNINGS_TRANSACTIONS.map((t) => {
            const Icon = ICONS[t.type] || Coins;
            const positive = t.amount >= 0;
            return (
              <div key={t.id} className="p-4 flex items-center gap-3">
                <div className={`w-9 h-9 rounded-full flex items-center justify-center ${positive ? "bg-[#FFC107]/10 text-[#FFC107]" : "bg-[#EF4444]/10 text-[#EF4444]"}`}>
                  {positive ? <Icon size={16} /> : <ArrowDownLeft size={16} />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[13px] truncate">{t.label}</div>
                  <div className="text-[11px] text-[#52525b]">{t.date}</div>
                </div>
                <div className={`text-[14px] font-black ${positive ? "text-[#FFC107]" : "text-[#A1A1AA]"}`}>
                  {positive ? "+" : ""}${Math.abs(t.amount)}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-end md:items-center justify-center p-4" onClick={() => setModal(false)}>
          <div className="sb-card p-6 max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <div className="sb-eyebrow">Payouts</div>
              <button onClick={() => setModal(false)}><X size={16} /></button>
            </div>
            <h3 className="mt-3 text-[18px] font-black">Coming soon</h3>
            <p className="mt-2 text-[13px] text-[#A1A1AA]">
              Payout setup coming soon — Stripe integration is not enabled in this prototype.
            </p>
            <button onClick={() => { setModal(false); toast.success("You'll be notified when payouts are live."); }} className="mt-4 sb-btn-primary w-full text-[12px]">
              Notify Me
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
